module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-designs/designs-7-c1c477a9c77382d6d6ed9899a39fe278.jpg";